import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { alpha, Box, Button, ButtonBase, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FaCircleInfo, FaHotel } from "react-icons/fa6";
import { GiAirplaneArrival, GiFullMotorcycleHelmet, GiMechanicGarage, GiMeepleGroup } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';
import SpecificOfferCard from './SpecificOfferCard';

const SpecificOfferSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Box mt={4}>
            <Grid container spacing={{ xs: 2, sm: 4 }}>
                <Grid item xs={12} md={4}>
                    <SpecificOfferCard
                        icon={<GiFullMotorcycleHelmet size={30} />}
                        title={t("specificOffer.equipment.title")}
                        description={t("specificOffer.equipment.description")}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <SpecificOfferCard
                        icon={<GiMeepleGroup size={30} />}
                        title={t("specificOffer.staff.title")}
                        description={""}
                        descriptionComponent={(
                            <Box>
                                <Button
                                    onClick={() => navigate("/our-team")}
                                    variant='outlined'
                                    color='secondary'
                                    sx={(theme) => ({
                                        padding: "10px 24px",
                                        paddingRight: "12px",
                                        boxShadow: `rgba(0,0,0, 0.2) 0px 0px 6px 1px`,
                                    })}
                                >
                                    Detalji
                                    <NavigateNextRoundedIcon fontSize='small' />
                                </Button>
                            </Box>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <SpecificOfferCard
                        icon={<FaCircleInfo size={30} />}
                        title={t("specificOffer.aboutUs.title")}
                        description={""}
                        descriptionComponent={(
                            <Box>
                                <Button
                                    onClick={() => navigate("/about-us")}
                                    variant='outlined'
                                    color='secondary'
                                    sx={(theme) => ({
                                        padding: "10px 24px",
                                        paddingRight: "12px",
                                    })}
                                >
                                    Detalji
                                    <NavigateNextRoundedIcon fontSize='small' />
                                </Button>
                            </Box>
                        )}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <SpecificOfferCard
                        icon={<FaHotel size={30} />}
                        title={t("specificOffer.hotel.title")}
                        description={t("specificOffer.hotel.description")}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <SpecificOfferCard
                        icon={<GiMechanicGarage size={30} />}
                        title={t("specificOffer.services.title")}
                        description={t("specificOffer.services.description")}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <SpecificOfferCard
                        icon={<GiAirplaneArrival size={30} />}
                        title={t("specificOffer.transfer.title")}
                        description={t("specificOffer.transfer.description")}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default SpecificOfferSection;
